export interface FaqItemData {
  question: string;
  answer: string;
}

export const faqData: FaqItemData[] = [
  {
    question: "How do I start a digital inspection?",
    answer: "Log in, select your site from the dashboard, and click 'Start Inspection'. You'll see a checklist tailored to your site's specific BMPs."
  },
  {
    question: "Where does the weather data come from?",
    answer: "RunOffTrack uses Open-Meteo data for weather context. Your permit may require an on-site gauge or another specific source, so verify the measurement and recordkeeping rules that apply to your project."
  },
  {
    question: "Can I use this on my phone?",
    answer: "Absolutely. RunOffTrack is a Progressive Web App (PWA) designed for mobile use in the field, even with spotty cell service."
  },
  {
    question: "What happens if I miss an inspection?",
    answer: "The dashboard flags the site's inspection date as overdue. Follow the applicable permit and your organization's process for documenting and correcting a missed inspection."
  }
];
